import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import {
  pageNames,
  routePaths,
  privateRoutes,
  publicRoutes,
} from "./routesConfig";
import PublicRoute from "./publicRoutes";
import PrivateRoute from "./privateRoutes";
import VerifyEmail from "pages/verify-email";

const BaseRoutes = () => {
  const availableRoutes = Object.values(privateRoutes);
  const availablePublicRoutes = Object.values(publicRoutes);
  //   const ErrorRoute = Object.values(errorPageRoute);

  return (
    <Routes>
      {availableRoutes.map(
        ({ component: Component, name, path, subPage, ...rest }) => {
          return (
            <Route
              path={path}
              key={`route-${name}`}
              element={
                <PrivateRoute>
                  <Component
                    SubPage={subPage != null ? subPage : null}
                    {...rest}
                  />
                </PrivateRoute>
              }
              {...rest}
            />
          );
        }
      )}
      {availablePublicRoutes.map(({ component: Component, name, path }) => {
        return (
          <Route
            path={path}
            key={`route-${name}`}
            element={
              <PublicRoute>
                <Component />
              </PublicRoute>
            }
          />
        );
      })}
      <Route path="/verify-email" element={<VerifyEmail />} />
      {/* {ErrorRoute.map(({component: Component, name, path}) => {
        return (
          <Route path={path} key={`route-${name}`} element={<Component />} />
        );
      })}
      <Route path="*" element={<Navigate to={path.dashboard} />} /> */}
    </Routes>
  );
};
export default BaseRoutes;
